const GET_WORDPRESS_DATA_ENDPOINT = "/ccmc-website-services/get-wordpress-data";
const VALIDATE_TOKEN_ENDPOINT = "/ccmc-website-services/validate-token";
const LOGGING_PORTAL_ENDPOINT = "/ccmc-website-services/logging-portal";
const LOGGING_NAVIGATION_ENDPOINT = "/ccmc-website-services/logging-navigation";
const GET_MENU_ENDPOINT= "/ccmc-website-services/get-menu";
const PRIMARY_COLOR = "#00305E";
const SECONDARY_COLOR = "#11728D";
const RALEWAY_FONT_FAMILY = "Raleway";
const ROBOTO_FONT_FAMILY = "Roboto";

// Session and Auth constants
const AUTH_SESSIONS = {
  USER_SESSION_COOKIE_NAME: "userSession",
  AMP_USER_JWT_COOKIE_NAME: "Amp_User_Jwt",
  CC_GWUSERCONTEXT_COOKIE_NAME: "CC_GWUserContext",
  PC_GWUSERCONTEXT_COOKIE_NAME: "PC_GWUserContext",
  BC_GWUSERCONTEXT_COOKIE_NAME: "BC_GWUserContext",
  AMC_USER_JWT_COOKIE_NAME: "Amc_User_Jwt",
  AB_GWUSERCONTEXT_COOKIE_NAME: "AB_GWUserContext",
  AMP_SELECTED_POLICY_COOKIE_NAME: "Amp_SelectedPolicy",
  SOB_COOKIE_NAME: "sob",
}

// URL constants
const SIGN_IN_URL = "/sign-in";
const SIGN_OUT_URL = "/signout";

// Portal type constants
const PORTAL_TYPE_GENERAL = "general";

const appServerUrl = process.env.REACT_APP_SERVER_URL || 'https://dev.calcas.com';

const getWordpressBaseUrl = () => {
  const isWpAfdCachingEnabled = process.env.REACT_APP_IS_WP_AFD_CACHING_ENABLED === "true";
  return isWpAfdCachingEnabled ? process.env.REACT_APP_SERVER_URL : process.env.REACT_APP_WORDPRESS_URL;
};

export default {
  GET_WORDPRESS_DATA_ENDPOINT,
  VALIDATE_TOKEN_ENDPOINT,
  LOGGING_PORTAL_ENDPOINT,
  LOGGING_NAVIGATION_ENDPOINT,
  GET_MENU_ENDPOINT,
  PRIMARY_COLOR,
  SECONDARY_COLOR,
  RALEWAY_FONT_FAMILY,
  ROBOTO_FONT_FAMILY,
  AUTH_SESSIONS,
  SIGN_IN_URL,
  SIGN_OUT_URL,
  PORTAL_TYPE_GENERAL,
  getWordpressBaseUrl,
  appServerUrl,
};